// El backend valida el DTE antes de asignarle folio y, cuando lo rechaza,
// responde 400 con { msg, errores: [...] }. Mostrar esa lista es mucho más útil
// que un "ocurrió un error" genérico, porque dice exactamente qué corregir.
//
// Devuelve el array de errores, o null si la respuesta no trae ese formato
// (error de red, 500, timeout), caso en que corresponde el mensaje genérico.
export const erroresDeRespuesta = (error) => {
  let data = error?.response?.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return null;
    }
  }
  return Array.isArray(data?.errores) && data.errores.length > 0 ? data.errores : null;
};
